var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4291_53531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0014 6.5887C17.3009 6.5887 18.3543 5.53525 18.3543 4.23575C18.3543 2.93626 17.3009 1.88281 16.0014 1.88281C14.7019 1.88281 13.6484 2.93626 13.6484 4.23575C13.6484 5.53525 14.7019 6.5887 16.0014 6.5887Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58732 12.2362C7.88681 12.2362 8.94026 11.1827 8.94026 9.88321C8.94026 8.58372 7.88681 7.53027 6.58732 7.53027C5.28782 7.53027 4.23438 8.58372 4.23438 9.88321C4.23438 11.1827 5.28782 12.2362 6.58732 12.2362Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4154 14.118C26.7149 14.118 27.7684 13.0645 27.7684 11.7651C27.7684 10.4656 26.7149 9.41211 25.4154 9.41211C24.1159 9.41211 23.0625 10.4656 23.0625 11.7651C23.0625 13.0645 24.1159 14.118 25.4154 14.118Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7615 9.39572C19.7615 8.5678 19.4922 7.80193 19.0375 7.17969C17.3697 8.90204 14.6237 8.90173 12.956 7.17969C12.5014 7.80193 12.2321 8.5678 12.2321 9.39572V13.1604H19.7615V9.39572ZM10.3497 15.0595C10.3497 14.2273 10.0779 13.4578 9.619 12.8338C7.95292 14.5463 5.21768 14.5468 3.5511 12.8338C3.09219 13.4578 2.82031 14.2273 2.82031 15.0595V18.8242H10.3497V15.0595ZM29.1733 16.9418C29.1733 16.1097 28.9014 15.3401 28.4425 14.7162C26.7764 16.4287 24.0412 16.4292 22.3746 14.7162C21.9157 15.3401 21.6438 16.1097 21.6438 16.9418V20.7065H29.1733V16.9418Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1765 28.236V22.589H21.6471V28.236H19.7647V15.0596H12.2353V28.236H10.3529V20.7066H2.82353V28.236H0V30.1184H32V28.236H29.1765Z",
    fill: "#3176BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4291_53531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewNumber);
export default __webpack_public_path__ + "static/media/Overview-Number.560529fede33d3930f02a8eabaa0efed.svg";
export { ForwardRef as ReactComponent };